module.exports = __webpack_public_path__ + "img/aiguplogo2x.986f124b.png";